<template>
  <EventHorizontalProductShowcase
    v-if="products.length || pending"
    :products="products"
    :pending="pending"
    :title="showcaseTitle"
    :gtm-item-list-id="GtmItemListId.KitsPageKits"
    :algolia-insights-label="algoliaInsightsLabel"
    data-test-id="kit-events-section"
    :loader-products-count="products.length || 6"
  />
</template>

<script setup lang="ts">
import type { EventDescription } from '~/composables/types/event'
import { GtmItemListId } from '~/composables/useKftGtm/types'
import { useSimilarKits } from '~/composables/search/useSimilarKits'
import { getSimilarShowcaseSource } from '~/utils/typesenseSimilarEventsQuery'

const { title = undefined, algoliaInsightsLabel = 'Kits - Kits Page' } =
  defineProps<{
    title?: string
    algoliaInsightsLabel?: string
  }>()

const { t } = useI18n()
const eventData = inject<EventDescription>('eventData')

const showcaseTitle = computed(
  () => title ?? t('product.boxSimilarLabelOnEventPage')
)

// Engine-aware (KFT-4193): KFT API on algolia, products_* on typesense.
// Client-only — the parent mounts it near the viewport.
const { data: products, pending } = useSimilarKits(
  getSimilarShowcaseSource(eventData)
)
</script>
